module.exports = __webpack_public_path__ + "6606ca20233cd4206564bfde1f80962a.png";